<p-dialog modal="true" styleClass="atlas-dialog-m" position="top" [closable]="false" [(visible)]="show">
  <ng-template pTemplate="header">
    <h4>{{ 'committees.edit.committee-meetings.attendance.add-a-guest' | translate | ucfirst }}</h4>
  </ng-template>

  <ng-container *ngIf="!isSaving; else saving">
    <wl-profile-search-and-select (profileSelected)="addGuest($event)"></wl-profile-search-and-select>
  </ng-container>
  <ng-template #saving>
    <div class="mct-flex mct-row mct-justify-center mct-items-center">
      <wl-busy [show]="true" [isLarge]="true"></wl-busy>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <button type="button" class="atlas-btn atlas-btn-secondary" (click)="close()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
  </ng-template>
</p-dialog>
